
import React from 'react';
import { Tutorial, BomItem, TutorialSection } from '@/types/tutorial';
import { Printer } from '@/hooks/use-printer-search';
import { Contributor } from '@/hooks/use-contributors';
import { PartFilter } from '@/data/parts';
import BasicInformationSection from './BasicInformationSection';
import BomManager from './BomManager';
import SectionManager from './SectionManager';
import TutorialActionButtons from './TutorialActionButtons';
import CollapsibleSection from './CollapsibleSection';

interface TutorialEditorContentProps {
  tutorial: Partial<Tutorial>;
  selectedPrinters: Printer[];
  contributors: Contributor[];
  requirements: PartFilter[];
  isSubmitting: boolean;
  isUserLoggedIn: boolean;
  onTitleChange: (title: string) => void;
  onCoverImageChange: (coverImage: string) => void;
  onDescriptionChange: (description: string) => void;
  onTagsChange: (tags: string[]) => void;
  onPrintersChange: (printers: Printer[]) => void;
  onContributorsChange: (contributors: Contributor[]) => void;
  onRequirementsChange: (requirements: PartFilter[]) => void;
  onBomChange: (bom: BomItem[]) => void;
  onSectionsChange: (sections: TutorialSection[]) => void;
  onSaveDraft: () => void;
  onSubmitForReview: () => void;
}

const TutorialEditorContent: React.FC<TutorialEditorContentProps> = ({
  tutorial,
  selectedPrinters,
  contributors,
  requirements,
  isSubmitting,
  isUserLoggedIn,
  onTitleChange,
  onCoverImageChange,
  onDescriptionChange,
  onTagsChange,
  onPrintersChange,
  onContributorsChange,
  onRequirementsChange,
  onBomChange,
  onSectionsChange,
  onSaveDraft,
  onSubmitForReview
}) => {
  return (
    <div className="space-y-8 w-full">
      <div id="basic-info" className="w-full">
        <CollapsibleSection title="Basic Information">
          <BasicInformationSection
            title={tutorial.title || ""}
            coverImage={tutorial.coverImage || ""}
            shortDescription={tutorial.shortDescription || ""}
            tags={tutorial.tags || []}
            selectedPrinters={selectedPrinters}
            contributors={contributors}
            requirements={requirements}
            onTitleChange={onTitleChange}
            onCoverImageChange={onCoverImageChange}
            onDescriptionChange={onDescriptionChange}
            onTagsChange={onTagsChange}
            onPrintersChange={onPrintersChange}
            onContributorsChange={onContributorsChange}
            onRequirementsChange={onRequirementsChange}
          />
        </CollapsibleSection>
      </div>
      
      <div id="bom" className="w-full">
        <BomManager
          bom={tutorial.bom || []}
          onChange={onBomChange}
        />
      </div>

      <div id="sections" className="w-full">
        <SectionManager
          sections={tutorial.sections || []}
          onChange={onSectionsChange}
        />
      </div>

      <TutorialActionButtons
        isSubmitting={isSubmitting}
        isUserLoggedIn={isUserLoggedIn}
        onSaveDraft={onSaveDraft}
        onSubmitForReview={onSubmitForReview}
      />
    </div>
  );
};

export default TutorialEditorContent;
